import { Navigate } from "react-router-dom";
import { useSupplierServices } from "../hooks/useSupplierServices";

/**
 * ServiceProtectedRoute - Protects routes based on supplier's service_provided
 * @param {Object} props
 * @param {string|string[]} props.requiredService - Service(s) required to access the route
 * @param {React.ReactNode} props.children - Child component to render if service is available
 */
function ServiceProtectedRoute({ children, requiredService }) {
  const { hasService } = useSupplierServices();

  if (!requiredService) {
    return children;
  }

  const requiredServices = Array.isArray(requiredService)
    ? requiredService
    : [requiredService];

  const hasRequiredService = requiredServices.some((service) =>
    hasService(service)
  );

  if (!hasRequiredService) {
    return <Navigate to="/Dashboard" replace />;
  }

  return children;
}

export default ServiceProtectedRoute;
